export default function ({ store }) {
  store.dispatch('layout/hideAppBar')
}
